/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ targets: NonNullable<unknown> }} Swap_Targets_KeptInputs */

const en_us2_swap_targets_kept = /** @type {(inputs: Swap_Targets_KeptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Keeps ${i?.targets}; the load starts blank`)
};

const pt_br2_swap_targets_kept = /** @type {(inputs: Swap_Targets_KeptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mantém ${i?.targets}; a carga começa em branco`)
};

const es_419_swap_targets_kept = /** @type {(inputs: Swap_Targets_KeptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mantiene ${i?.targets}; la carga empieza en blanco`)
};

const pt_pt2_swap_targets_kept = /** @type {(inputs: Swap_Targets_KeptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mantém ${i?.targets}; a carga começa em branco`)
};

const fr_fr2_swap_targets_kept = /** @type {(inputs: Swap_Targets_KeptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Garde ${i?.targets} ; la charge part de zéro`)
};

const de_de2_swap_targets_kept = /** @type {(inputs: Swap_Targets_KeptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Behält ${i?.targets}; das Gewicht startet leer`)
};

const it_it2_swap_targets_kept = /** @type {(inputs: Swap_Targets_KeptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mantiene ${i?.targets}; il carico parte vuoto`)
};

/**
* | output |
* | --- |
* | "Keeps {targets}; the load starts blank" |
*
* @param {Swap_Targets_KeptInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_targets_kept = /** @type {((inputs: Swap_Targets_KeptInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Targets_KeptInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_targets_kept(inputs)
	if (locale === "es-419") return es_419_swap_targets_kept(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_targets_kept(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_targets_kept(inputs)
	if (locale === "de-DE") return de_de2_swap_targets_kept(inputs)
	if (locale === "it-IT") return it_it2_swap_targets_kept(inputs)
	return en_us2_swap_targets_kept(inputs)
});
export { swap_targets_kept as "swap.targets_kept" }